import Vue from "vue/dist/vue.esm";

var detailAthletes = Vue.extend({
  template: `
  <table class="table table-vote-number table-align-middle">
      <thead class="bg-gray-lighter text-bold">
      <tr height="34" class="text-nowrap">
        <th rowspan="2">晴予想</th>
        <th rowspan="2">雨予想</th>
        <th rowspan="2">車番</th>
        <th rowspan="2">選手名</th>
        <th rowspan="2">試走タイム</th>
        <th rowspan="2">年齢</th>
        <th rowspan="2">LG</th>
        <th rowspan="2">ハンデ</th>
        <th rowspan="2">スタート</th>
        <th rowspan="2">試走偏差</th>
        <th rowspan="2">現ランク</th>
        <th rowspan="2">審査ポイント</th>
        <th colspan="6">直近90日の成績</th>
        <th rowspan="2">走路</th>
        <th colspan="3">直近90日の成績</th>
        <th colspan="6">勝率（180日）</th>
      </tr>
      <tr height="34" class="text-nowrap">
        <th>1着</th>
        <th>2着</th>
        <th>3着</th>
        <th>着外</th>
        <th>単勝率</th>
        <th>連勝率</th>
        <th>平均試走タイム</th>
        <th>平均競走タイム</th>
        <th>最高競走タイム</th>
        <th colspan="2">単勝率</th>
        <th colspan="2">2連対率</th>
        <th colspan="2">3連対率</th>
      </tr>
      </thead>
    <tbody v-for="(athlete, index) in raceInfo.race_athletes" class="text-nowrap">
      <tr :class="['bg-lighten-' + athlete.entry_num, {'is-disabled': !athlete.on_sale}]">
        <td rowspan="2" class="bg-white text-center">
          <span v-if="raceInfo.prediction.marks">{{ print_prediction_mark(athlete.entry_num) }}</span>
        </td>
        <td rowspan="2" class="bg-white text-center">
          <span v-if="raceInfo.prediction.rain_marks">{{ print_prediction_rain_mark(athlete.entry_num) }}</span>
        </td>
        <td rowspan="2" height="68" :class="'bg-' + index" class="text-center text-bold">{{index}}</td>
        <td rowspan="2">
          <span :class="{'text-through': !athlete.on_sale}">{{athlete.name}}</span>
          <span v-if="!athlete.on_sale">（取消）</span>
        </td>
        <td rowspan="2">{{athlete.trial_time}}</td>
        <td rowspan="2">{{athlete.age}}</td>
        <td rowspan="2">{{athlete.locker_ground}}</td>
        <td rowspan="2">{{athlete.handicap}}</td>      
        <td rowspan="2">
          <span v-if="raceInfo.prediction.starts">{{ print_prediction_starts(athlete.entry_num) }}</span>
        </td>
        <td rowspan="2">{{athlete.trial_deviation}}</td>
        <td rowspan="2">{{athlete.class_name}}-{{athlete.rank}}</td>
        <td rowspan="2">{{athlete.recommend_point}}</td>
        <td rowspan="2">{{latest_num_1th(athlete)}}</td>
        <td rowspan="2">{{latest_num_2th(athlete)}}</td>
        <td rowspan="2">{{latest_num_3th(athlete)}}</td>
        <td rowspan="2">{{latest_num_other(athlete)}}</td>
        <td rowspan="2">{{latest_rate_1th(athlete)}}％</td>
        <td rowspan="2">{{latest_rate_2th(athlete)}}％</td>
        <td height="34">良</td>
        <td>{{athlete.latest_fine_trial_ave}}</td>
        <td>{{athlete.latest_fine_race_ave}}</td>
        <td>{{athlete.latest_fine_rate_high_score}}</td>
        <td>{{athlete.half_year_fine_rate_1th}}</td>
        <td>{{athlete.half_year_fine_num_1th}}/{{athlete.half_year_fine_num_all}}</td>
        <td>{{athlete.half_year_fine_rate_2th}}</td>
        <td>{{athlete.half_year_fine_num_1th + athlete.half_year_fine_num_2th}}/{{athlete.half_year_fine_num_all}}</td>
        <td>{{athlete.half_year_fine_rate_3th}}</td>
        <td>{{athlete.half_year_fine_num_1th + athlete.half_year_fine_num_2th + athlete.half_year_fine_num_3th}}/{{athlete.half_year_fine_num_all}}</td>
      </tr>
      <tr :class="['bg-lighten-' + athlete.entry_num, {'is-disabled': !athlete.on_sale}]">
        <td height="34">湿</td>
        <td>{{athlete.latest_wet_trial_ave}}</td>
        <td>{{athlete.latest_wet_race_ave}}</td>
        <td>{{athlete.latest_wet_rate_high_score}}</td>
        <td>{{athlete.half_year_wet_rate_1th}}</td>
        <td>{{athlete.half_year_wet_num_1th}}/{{athlete.half_year_wet_num_all}}</td>
        <td>{{athlete.half_year_wet_rate_2th}}</td>
        <td>{{athlete.half_year_wet_num_1th + athlete.half_year_wet_num_2th}}/{{athlete.half_year_wet_num_all}}</td>
        <td>{{athlete.half_year_wet_rate_3th}}</td>
        <td>{{athlete.half_year_wet_num_1th + athlete.half_year_wet_num_2th + athlete.half_year_wet_num_3th}}/{{athlete.half_year_wet_num_all}}</td>
      </tr>
    </tbody>
  </table>
  `,
  methods: {
    // 直近90日の良走路、湿走路、併せた1着の数
    latest_num_1th: function(athlete) {
      return athlete.latest_fine_num_1th + athlete.latest_wet_num_1th;
    },
    // 直近90日の良走路、湿走路、併せた2着の数
    latest_num_2th: function(athlete) {
      return athlete.latest_fine_num_2th + athlete.latest_wet_num_2th;
    },
    // 直近90日の良走路、湿走路、併せた3着の数
    latest_num_3th: function(athlete) {
      return athlete.latest_fine_num_3th + athlete.latest_wet_num_3th;
    },
    // 直近90日の良走路、湿走路、併せた1着、2着、3着の数
    latest_num_other: function(athlete) {
      return athlete.latest_fine_num_other + athlete.latest_wet_num_other;
    },
    // 直近90日の出走回数
    latest_num_all: function(athlete) {
      return this.latest_num_1th(athlete) + this.latest_num_2th(athlete) + this.latest_num_3th(athlete) + this.latest_num_other(athlete);
    },
    // 直近90日の良走路、湿走路、併せた単勝率（1着）
    latest_rate_1th: function(athlete) {
      var rate = this.latest_num_1th(athlete) / this.latest_num_all(athlete) * 100
      return chari.util.adjustNum(rate, 1) || 0;
    },
    // 直近90日の良走路、湿走路、併せた連勝率
    latest_rate_2th: function(athlete) {
      var rate = (this.latest_num_1th(athlete) + this.latest_num_2th(athlete)) / this.latest_num_all(athlete) * 100
      return chari.util.adjustNum(rate, 1) || 0;
    },
    print_prediction_mark: function(syaban) {
      var i = syaban - 1;
      return this.raceInfo.prediction.marks[i];
    },
    print_prediction_rain_mark: function(syaban) {
      var i = syaban - 1;
      return this.raceInfo.prediction.rain_marks[i];
    },
    print_prediction_starts: function(syaban) {
      var i = syaban - 1;
      return this.raceInfo.prediction.starts[i];
    }
  }
});

export default {
  detailAthletes
}
